<template>
  <div class="order">
    <div class="mt-5 pt-3">
      <h1>Order</h1>
    </div>
    <snackbar :text="text" :status="status" v-if="text"/>

    <v-container style="max-width: 85%" class="mt-3">
      <waiting v-if="loading"/>
      <order-pop v-if="success" :isOrderV2="true" @closePop="success = $event"/>
      <confirm v-if="confirm" :message="confirmMessage" @submit="ok()" @closePop="confirm = $event"/>

      <v-card class="mb-5">
        <tabs :active="1" :tabs="orderTabs"></tabs>
      </v-card>

      <v-card>
        <v-container>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-chip class="title green white--text pa-2" label style="position: absolute; left: 35px; top: -20px">Order Detail</v-chip>
              <v-text-field
                solo
                v-model="inputOrder.order_number"
                color="green"
                :rules="orderRules"
                label="Order Number"
                required
                class="mt-3"
              ></v-text-field>

              <v-combobox
                solo
                v-model="inputOrder.delivery_method"
                :items="deliveryMethods"
                :rules="[v => !!v || 'Delivery Method is required']"
                label="Delivery Method"
              ></v-combobox>

              <v-radio-group
                v-if="inputOrder.delivery_method === 'WHATSAPP'"
                v-model="inputOrder.type"
                row
                :hide-details="true"
                class="mt-0 mb-4"
              >
                <v-radio
                  label="ORDER"
                  value="ORDER"
                  color="#4dbd77"
                ></v-radio>
                <v-radio
                  label="GIFT"
                  value="GIFT"
                  color="#4dbd77"
                ></v-radio>
                <span class="ml-2 template-label" @click="handleTemplate">See template</span>
              </v-radio-group>

              <v-autocomplete
                solo
                v-model="inputOrder.sku_voucher"
                color="green"
                :items="filterSkus"
                item-text="sku_name"
                item-value="sku"
                return-object
                :disabled="!inputOrder.delivery_method"
                :rules="[v => !!v || 'SKU is required']"
                label="SKU Nominal"
              ></v-autocomplete>

              <v-container style="border: 1px solid lightgray; border-radius: 20px" class="pa-4 mt-4">
                <v-btn v-if="clientList.length === 0" color="green white--text" @click="onPickFile">
                  <v-icon>mdi-upload</v-icon> Upload File
                </v-btn>

                <v-btn v-if="clientList.length !== 0" color="red white--text" @click="resetFile">
                  <v-icon>mdi-delete</v-icon> Reset File
                </v-btn>

                <v-btn sm color="blue white--text" @click="setTemplate">
                  <v-icon>mdi-download</v-icon> Template
                </v-btn>

                <v-text-field
                  label="File Name (.xlsx)"
                  disabled
                  v-model='inputOrder.fileInput'
                  :rules="fileRules"
                ></v-text-field>

                <!-- Hidden -->
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="*/*"
                  @change="onFilePicked">

                <span class="error--text" v-if="!correctTemplate && inputOrder.fileInput"> Invalid Format Template </span>
                <v-card class="responsive m10">
                  <h2 class="m10">Customer List</h2>
                  <table class="table-custom">
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Quantity</th>
                    </tr>
                    <tbody v-if="clientList.length !== 0">
                      <tr v-for="(item, index) in clientList"
                        :key="index"
                      >
                        <td>
                          <v-icon color="green" v-if="!item.errorEmail && !item.errorPhone && !item.errorQty">mdi-check</v-icon>
                          <v-icon color="red" v-if="item.errorEmail || item.errorPhone || item.errorQty">mdi-close</v-icon>
                        </td>
                        <td>{{item.name}}</td>
                        <td>
                          <span v-if="item.errorEmail" class="error--text">{{item.email}}</span>
                          <span v-if="!item.errorEmail">{{item.email}}</span>
                        </td>
                        <td v-if="item.errorPhone" class="error--text">{{item.phone}}</td>
                        <td v-if="!item.errorPhone">{{item.phone}}</td>
                        <td>
                          <span v-if="item.errorQty" class="error--text">{{item.quantity}}</span>
                          <span v-if="!item.errorQty">{{item.quantity}}</span>
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-if="clientList.length === 0">
                      <tr>
                        <td colspan="5" style="text-align:center"> No Data</td>
                      </tr>
                    </tbody>
                  </table>
                </v-card>
              </v-container>

              <Captcha
                v-if="appMode !== 'development'"
                class="mt-2"
                :rules="'You must agree to continue'"
                :verified="inputOrder.checkbox"
                :status="statCheckbox"
                @verify="inputOrder.checkbox = $event"/>

            </v-container>

            <v-btn
              v-if="!isReceivedOTP"
              :disabled="!valid"
              class="green white--text"
              @click="sendOtp()"
            >
              Send OTP
            </v-btn>
          </v-form>

          <div v-if="isReceivedOTP">
            <div class="otp-section">
              <v-text-field
                solo
                v-model="otpValue"
                color="green"
                :rules="[v => !!v || 'OTP Code is required']"
                label="OTP Code"
                required
                class="mt-3"
              ></v-text-field>

              <v-btn
                :disabled="!valid"
                large
                class="green white--text px-2"
                style="margin-top:-4px"
                @click="resendOTP()"
              >
                <div class="btn-resend">
                  <v-icon small class="mr-2">mdi-reload</v-icon>
                  <OtpCountdown v-if="isCountdown" @finish="isCountdown = false"/>
                  <span v-else> Resend OTP </span>
                </div>
              </v-btn>
            </div>

            <v-btn
              :disabled="!valid || !otpValue"
              class="green white--text"
              @click="sendOpenOrder"
            >
              Create Order
            </v-btn>
          </div>

        </v-container>
      </v-card>
    </v-container>
    <delivery-method-template v-if="openTemplate" @close="handleTemplate" :value="inputOrder.type" />
  </div>
</template>

<script>
import axios from '@/helpers/axios'
import { signature } from '@/helpers/signature'
import Captcha from '@/components/Captcha.vue'
import OrderPop from '@/components/OrderPop'
import Confirm from '@/components/Confirm'
import Snackbar from '@/components/Snackbar.vue'
import Waiting from '@/components/Waiting'
import Tabs from '@/components/v2/Tabs'
import { mapActions, mapState } from 'vuex'
import XLSX from 'xlsx'
import _ from 'lodash'
import DeliveryMethodTemplate from '../components/DeliveryMethodTemplate.vue'
import OtpCountdown from '../components/OtpCountdown'
import moment from 'moment'

const JATIS = 'Jatis'
const VC = 'VC'
const ULTRAVOUCHER = 'ULTRAVOUCHER'

export default {
  name: 'order2',
  components: {
    Snackbar,
    Waiting,
    OrderPop,
    Captcha,
    Confirm,
    Tabs,
    DeliveryMethodTemplate,
    OtpCountdown
  },
  data () {
    return {
      success: null,
      confirm: false,
      confirmMessage: 'Make sure the data is correct. If there are errors in charging, it is not Ultravoucher`s responsibility',
      defaultOrder: {
        reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
        order_number: '',
        sku_voucher: null,
        delivery_method: null,
        checkbox: null,
        fileInput: null
      },
      inputOrder: {
        reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
        order_number: '',
        sku_voucher: null,
        delivery_method: null,
        checkbox: null,
        fileInput: null,
        type: ''
      },
      reqId: `ReqId-${new Date().getTime()}-PO-${Math.floor(Math.random() * (new Date().getTime()) + 1)}`,
      order_number: '',
      orderRules: [
        v => !!v || 'Order number is required',
        v => (v && v.length >= 6) || 'Minimum order number is 6 characters',
        v => /^[\w-]+$/.test(v) || 'Invalid character'
      ],
      sku_voucher: null,
      skus: [],
      filterSkus: [],
      deliveryMethods: ['EMAIL', 'ULTRAVOUCHER', 'SMS', 'WHATSAPP'],
      fileRules: [
        v => !!v || 'File Upload is Required',
        v => /.*\.(xlsx)/.test(v) || 'File Upload must be xlsx file'
      ],
      text: null,
      valid: true,
      statCheckbox: true,
      loading: false,
      search: null,
      correctTemplate: false,
      clientList: [],
      totalQuantity: 0,
      openTemplate: false,
      isReceivedOTP: false,
      otpValue: '',
      otpData: null,
      status: 'error',
      isCountdown: false
    }
  },
  methods: {
    ...mapActions([
      'getTransDefaultv2'
    ]),
    validate () {
      if (this.$refs.form.validate() && this.validateCheckbox() && this.correctTemplate) {
        let error = this.clientList.find(val => val.errorEmail || val.errorPhone || val.errorQty)
        if (error) {
          this.text = 'There is Invalid Format for Email or Phone Number or Zero Quantity'
        } else {
          this.confirm = true
        }
      }
    },
    validateCheckbox () {
      // If in development mode, skip the captcha verification
      if (this.appMode === 'development') {
        return true
      } else {
        if (this.inputOrder.checkbox) {
          return true
        } else {
          return false
        }
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetFile () {
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
      this.inputOrder.fileInput = ''
      this.clientList = []
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    getSKUs () {
      let url = `/sku?app_id=${this.appid}&app_key=${this.appkey}&accesstoken=${this.token}&brandcode=`
      axios.get(url)
        .then(response => {
          let dataSKU = response.data.data
          let filterSKU = dataSKU.filter(el => el.product_status !== 'tidak-aktif') // filter sku aktif
          this.skus = filterSKU
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
        })
    },
    sendOpenOrder () {
      this.statCheckbox = this.validateCheckbox()
      this.validate()
    },
    setDataBody () {
      let dataBody = {
        request_id: this.inputOrder.reqId,
        order_number: this.inputOrder.order_number,
        sku: this.inputOrder.sku_voucher ? this.inputOrder.sku_voucher.sku : '',
        qty: String(this.totalQuantity),
        receiver_name: 'Ultravoucher',
        receiver_email: 'info@ultravoucher.co.id',
        receiver_phone: '08119276700'
      }
      return dataBody
    },
    setPayload () {
      let payload = {
        request_id: this.inputOrder.reqId,
        order_number: this.inputOrder.order_number,
        sku: this.inputOrder.sku_voucher ? this.inputOrder.sku_voucher.sku : '',
        qty: String(this.totalQuantity),
        receiver_name: 'Ultravoucher',
        receiver_email: 'info@ultravoucher.co.id',
        receiver_phone: '08119276700',
        delivery_method: this.inputOrder.delivery_method,
        type: this.inputOrder.delivery_method === 'WHATSAPP' ? this.inputOrder.type : '',
        data_customers: this.clientList,
        otp: this.otpValue
      }
      return payload
    },
    ok () {
      this.loading = true
      this.snackbar = true
      this.process()
    },
    process () {
      let reqSignature = signature(this.setDataBody(), 'sendOpenOrder')
      axios.defaults.headers = {
        accessToken: this.token,
        milliseconds: this.expired,
        signature: reqSignature
      }

      let url = '/openOrderV2'

      axios.post(url, this.setPayload())
        .then(response => {
          if (response.data.status !== 200) {
            if (response.data.meta.status === 'error') {
              this.text = response.data.meta.message
              this.success = false
            } else {
              this.text = response.data.message
              this.success = false
            }
          } else {
            this.success = true
            this.inputOrder = Object.assign({}, this.defaultOrder)
            this.reset()
            this.resetFile()
            this.clientList = []
            this.getTransDefaultv2()
            this.statCheckbox = true
            this.inputOrder.checkbox = null
            this.otpValue = ''
            this.otpData = null
            this.isReceivedOTP = false
            localStorage.removeItem('o_exp_at')
            this.isCountdown = false
          }
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
        })
        .finally(() => {
          this.confirm = false
          this.loading = false
        })
    },
    onPickFile () {
      if (!this.correctTemplate && this.inputOrder.fileInput) {
        this.resetFile()
      }
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.inputOrder.fileInput = files[0].name
        this.previewFiles(event)
      } else {
        this.inputOrder.fileInput = ''
        this.clientList = []
        this.correctTemplate = false
      }
    },
    previewFiles (e) {
      let me = this
      let files = e.target.files
      let f = files[0]
      let reader = new FileReader()
      if (/.*\.(xlsx)/.test(f.name)) {
        reader.onload = function (e) {
          let data = new Uint8Array(e.target.result)
          let workbook = XLSX.read(data, { type: 'array' })
          let sheetName = workbook.SheetNames[0]
          let worksheet = workbook.Sheets[sheetName]
          let value = XLSX.utils.sheet_to_json(worksheet)
          me.correctTemplate = me.validateTemplate(value)
          if (me.correctTemplate) {
            me.setClientList(value)
          } else {
            me.clientList = []
          }
        }
        reader.readAsArrayBuffer(f)
      }
    },
    validateTemplate (datas) {
      if (datas.length > 0) {
        if (_.has(datas[0], 'name') && _.has(datas[0], 'email') && _.has(datas[0], 'phone') && _.has(datas[0], 'quantity')) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    validateEmail (value) {
      let val = String(value).trim()
      return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)
    },
    validatePhone (value) {
      let val = String(value).trim()
      return /^0\d{9,14}$/.test(val)
    },
    validateQuantity (value) {
      let val = String(value).trim()
      return (/^[\d]+$/.test(val) && val > 0)
    },
    setClientList (value) {
      this.clientList = []
      this.totalQuantity = 0
      value.map(data => {
        this.clientList.push({
          name: data.name.trim(),
          email: data.email.trim(),
          phone: data.phone,
          quantity: data.quantity,
          errorQty: !this.validateQuantity(data.quantity),
          errorEmail: !this.validateEmail(data.email),
          errorPhone: !this.validatePhone(data.phone)
        })
        this.totalQuantity += Number(data.quantity)
      })
    },
    setTemplate () {
      let data = [
        { name: 'Customer Name', email: 'customer@gmail.com', phone: '081201234567', quantity: '10' }
      ]
      let customers = XLSX.utils.json_to_sheet(data)
      var wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, customers, 'Customers')
      // export Excel file
      XLSX.writeFile(wb, 'Customer_list.xlsx')
    },
    checkOrderDestination (value) {
      let skuVoucher = this.inputOrder.sku_voucher
      if (value === ULTRAVOUCHER) {
        if (skuVoucher && skuVoucher.order_destination !== JATIS) {
          this.inputOrder.sku_voucher = null
        }
      } else {
        if (skuVoucher && skuVoucher.order_destination !== VC) {
          this.inputOrder.sku_voucher = null
        }
      }
    },
    checkFilterSkus (value) {
      if (value === ULTRAVOUCHER) {
        this.filterSkus = _.filter(this.skus, (val) => { return val.order_destination === JATIS })
      } else {
        this.filterSkus = this.skus
      }
    },
    handleTemplate () {
      this.openTemplate = !this.openTemplate
    },
    sendOtp () {
      this.statCheckbox = this.validateCheckbox()
      if (this.$refs.form.validate() && this.validateCheckbox() && this.correctTemplate) {
        let error = this.clientList.find(val => val.errorEmail || val.errorPhone || val.errorQty)
        if (error) {
          this.text = 'There is Invalid Format for Email or Phone Number or Zero Quantity'
        } else {
          this.onSendOtp()
        }
      }
    },
    resendOTP () {
      const expiredAt = localStorage.getItem('o_exp_at') ? moment(localStorage.getItem('o_exp_at')) : moment()
      const now = moment()

      if (now.isAfter(expiredAt)) {
        this.sendOtp()
      } else {
        const duration = moment.duration(expiredAt.diff(now))

        const minutes = duration.minutes()
        const seconds = duration.seconds()

        this.text = `Failed, please wait for ${minutes} minutes and ${seconds} seconds`
      }
    },
    onSendOtp () {
      let url = `/create-otp`

      axios.defaults.headers = {
        accessToken: this.token
      }
      this.loading = true
      axios.post(url, { type: 'email' })
        .then(response => {
          this.otpData = response.data
          this.isReceivedOTP = true
          localStorage.setItem('o_exp_at', moment().add(5, 'minutes'))
          this.text = 'Successfully sent OTP to your email'
          this.status = 'success'
          this.isCountdown = true
        })
        .catch(error => {
          if (error.response.data.code === 'TOE001') {
            this.$store.dispatch('refresh')
          }
          if (error.response.data.code === 'TOE002') {
            this.$store.dispatch('clear')
          }
          this.text = error.response.data.message
        }).finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    ...mapState([
      'appid',
      'appkey',
      'token',
      'expired',
      'transDefault',
      'orderTabs'
    ]),
    appMode () {
      return process.env.VUE_APP_MODE
    }
  },
  watch: {
    text () {
      setTimeout(() => {
        this.text = null
        this.status = 'error'
      }, 5000)
    },
    'inputOrder.delivery_method' (val) {
      this.checkOrderDestination(val)
      this.checkFilterSkus(val)
    }
  },
  mounted () {
    this.getSKUs()
  }
}
</script>

<style scoped>
.green {
  background: #27bb8b!important;
}
.green--text {
  color: #4dbd99!important;
  border-color: #4dbd99 !important;
}
.responsive {
  overflow-y: scroll;
  max-height: 500px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
}
tr {
  border: 1px solid #ddd;
}
th, td {
  text-align: left;
  padding: 8px;
}
tr:nth-child(even){background-color: #f2f2f2}
.fs-12 {
  font-size: 12px;
}
.m10 {
  margin: 10px 0 10px 0;
}

.template-label {
  color: #2577F2;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  cursor: pointer;
}

.otp-section {
  width: 40%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-resend {
  display: flex;
  gap: 4px;
  align-items: center;
}

</style>
